import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BackordersRoutingModule } from './backorders-routing.module';
import { HttpClient } from '@angular/common/http';

import { BackorderPageContainer } from './containers/backorder-page-container/backorder-page-container';
import { BackorderPageComponent } from './components/backorder-page/backorder-page.component';
import { BackorderTableComponent } from './components/backorder-table/backorder-table.component';
import { BackorderTableRowComponent } from './components/backorder-table-row/backorder-table-row.component';


@NgModule({
  imports: [
    CommonModule,
    BackordersRoutingModule
  ],
  declarations: [
    BackorderPageContainer,
    BackorderPageComponent,
    BackorderTableComponent,
    BackorderTableRowComponent
  ]
})
export class BackordersModule { 
  public static forRoot() {
    return {
      ngModule: RootBackordersModule,
      providers: [
        HttpClient
      ]
    }
  }
}


@NgModule({
  imports: [
    CommonModule,
    BackordersModule
  ],
  declarations: []
})
export class RootBackordersModule { }
